module.exports = __webpack_public_path__ + "img/pic05.7e74deeb.jpg";